(function(konto) {
	konto.gs = {};
} (konto = window.konto));